<script setup lang="ts">
import { Tooltip } from 'floating-vue'
import 'floating-vue/dist/style.css'

import type { PropType } from 'vue'
import type { PlacementDropdownOpt } from '@/types/components.interfaces'

defineProps({
  content: {
    type: String,
    required: true,
  },
  placement: {
    type: String as PropType<PlacementDropdownOpt>,
    default: 'auto',
  },
})
</script>

<template>
  <Tooltip handle-resize :placement="placement">
    <slot />

    <template #popper>
      {{ content }}
    </template>
  </Tooltip>
</template>

<style lang="postcss">
.v-popper.v-popper--theme-tooltip {
  @apply inline p-1;
}

.v-popper__popper.v-popper--theme-tooltip.v-popper__popper--shown {
  @apply max-w-xs;

  .v-popper__inner {
    @apply text-sm font-normal text-white max-w-xs;
    @apply bg-fontcolor-900 px-3 py-2 rounded;
  }

  .v-popper__arrow-outer {
    @apply border-fontcolor-900;
  }
}
.v-popper__popper.v-popper--theme-tooltip.v-popper__popper--hidden {
  @apply max-w-xs;
}
</style>
